<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Client Emails</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="add" @click="addClientEmail" color="danger" type="border" v-if="abilities.can('create', 'client-email')"
            >Add</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">
          <v-select v-model="per_page" :options="size_per_page"/>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="7"
          vs-sm="4"
          vs-xs="12"
        >
         <div class="p-1">
            <span>Search Client Email: </span>
          </div>
         

          <ClientAutocomplete
          :key="clientEmailComponentKey" 
            class="searchbox"
            :list="searchClientEmail"
            :searchOn="'company_or_registration_no'"
            @event-name="handleChildEvent"
          ></ClientAutocomplete>
                    <vs-icon class="pl-5 pointer" icon="cancel" @click="resetClientEmail" size="small"
            ></vs-icon
          >

        </vs-col>
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">
                          <!-- <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination> -->

         
        </vs-col>
      </vs-row>

      <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="clients_email"
      >
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="client_id">Client</vs-th>
          <vs-th sort-key="user_id">Elomark User</vs-th>
          <vs-th sort-key="username">Username</vs-th>
          <vs-th sort-key="email">Email</vs-th>
          <vs-th sort-key="status">Status</vs-th>
           <vs-th >Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].client_id">
              {{ data[indextr].client_name }}
            </vs-td>
            <vs-td :data="data[indextr].user_id">
              {{ data[indextr].elomark_user_name }}
            </vs-td>
            <vs-td :data="data[indextr].username">
              {{data[indextr].username}}
            </vs-td>
             <vs-td :data="data[indextr].email">
              {{data[indextr].email}}
            </vs-td>
             <vs-td :data="data[indextr].status">
              {{data[indextr].status}}
            </vs-td>
            <vs-td :data="data[indextr].actions">
              <vs-icon v-if="abilities.can('read', 'client-email')"
                class="ml-10 removeButton"
                @click="viewClientEmail(data[indextr].id)"
                color="success"
                icon="visibility"
              ></vs-icon>
              <vs-icon v-if="abilities.can('update', 'client-email')"
                class="ml-10 removeButton"
                @click="editClientEmail(data[indextr].id)"
                color="success"
                icon="edit"
              ></vs-icon>
              <vs-icon v-if="abilities.can('delete', 'client-email')"
                class="ml-10 removeButton"
                @click="confirmDeleteClientEmail(data[indextr].id)"
                color="success"
                icon="delete"
              ></vs-icon>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data: () => ({
    clients_email:[],
                            abilities : null,

    clientEmailComponentKey:0,
    selected: [],
    log: [],
    clients: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    size_per_page: [10,20,50,100,500],
    per_page: 10,
    paginationAttr:{
      'page_no':1,
      'per_page':10
    }
  }),
  components: {
    ClientAutocomplete,
    "v-select": vSelect
  },
  watch: {
    currentx: function(val) {
      this.paginationSetPageSize()
    },
    per_page:function(val){
            this.paginationSetPageSize()
    }
  },
  methods: {
    resetClientEmail(){
        this.fetchClientsEmail()
              this.clientEmailComponentKey += 1;
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        'page_no':this.currentx,
        'per_page':this.per_page
      }
      this.fetchClientsEmail();
    },
    searchClientEmail(inputValue) {
      return this.$store
        .dispatch("clientsManagement/searchClientEmail", inputValue)
        .then(response => {
          if (response) {
            let data =
              JSON.parse(moduleClientsManagement.state.company_or_registration_no)
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addClientEmail() {
      this.$router.push({ path: "/clients/addEmail" });
    },
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`);
    },
    viewClientEmail(id) {
      this.$router.replace("/clients/emailList/view/" + id);
    },
    editClientEmail(id) {
      this.$router.replace("/clients/emailList/edit/" + id);
    },
    handleChildEvent(){
      let client_id = moduleClientsManagement.state.clients.datas[0].id
       this.fetchClientEmailWithClientId(client_id)
      // console.log("Client" , this.clients)
    },
    fetchClientEmailWithClientId(clientId){
    this.$store
      .dispatch("clientsManagement/fetchClientEmailWithClientId", clientId)
      .then(res => {
        console.log(res.data)
        this.clients_email = []
        this.clients_email.push(res.data)
          // let result = res.data
        
          // this.clients_email = 
      })
    },
    confirmDeleteClientEmail(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Client`,
        accept: this.deleteClientEmail,
        acceptText: "Delete"
      });
    },
    deleteClientEmail() {
      this.$store
        .dispatch("clientsManagement/removeClientEmail", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchClientsEmail();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Client Deleted",
        text: "The client was successfully deleted"
      });
    },
    fetchClientsEmail() {
      this.$store
        .dispatch("clientsManagement/fetchAllClientsEmail", this.paginationAttr)
        .then(res => {
          this.clients_email = res.data.datas
          this.total = res.data.total;
          this.per_page = res.data.per_page;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  },
  created() {
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });
    if (!moduleClientsManagement.isRegistered) {
      this.$store.registerModule(
        "clientsManagement",
        moduleClientsManagement
      );
      moduleClientsManagement.isRegistered = true;
    }
    this.fetchClientsEmail();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.pointer{
  cursor: pointer;
}

.item.expanded{
    background-color: white !important;
    color: black !important;
}

.tr-table-state-primary, .vs-table-primary .is-selected {
    background: none !important;
    box-shadow: none !important;
}


.tr-table-state-primary, .vs-table-primary .is-selected {
    color: #626262 !important;
    -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary),1)!important;
    box-shadow: 0 0 1px 0 rgba(var(--vs-primary),1)!important;
}

.address_th{
  padding: 30px;
}

.address_td{
  padding: 30px;
      font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
